export default "__VITE_ASSET__171dfa79__"